export default "__VITE_ASSET__CoYfn_hq__"